import { render, staticRenderFns } from "./edit_admin_super.vue?vue&type=template&id=4dbb6006&"
import script from "./edit_admin_super.vue?vue&type=script&lang=js&"
export * from "./edit_admin_super.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports